<div class="multiple-file-upload-container">
  <nz-upload class="multiple-file-upload"
             [nzDirectory]="config?.allowDirectoryUpload || false"
             [nzAccept]="config?.acceptedFileTypes"
             [nzMultiple]="true"
             [nzListType]="config?.listType || 'picture-card'"
             [nzFileList]="fileList"
             [nzBeforeUpload]="beforeUpload"
             [nzRemove]="handleRemove"
             [nzDisabled]="isDisabled"
             [nzShowUploadList]="config.scrollable ? false : { showPreviewIcon: false, showRemoveIcon: true, showDownloadIcon: false }"
             [nzLimit]="config.maxFileCount"
             [nzSize]="config.maxFileSize"
             [nzCustomRequest]="customRequest"
             [nzPreview]="handlePreview"
             (nzChange)="handleChange($event)">

    <div nz-tooltip
         [nzTooltipTitle]="getTooltipText()"
         nzTooltipPlacement="top">
      <rappider-button [text]="config.uploadText || 'Upload'"
                       [disabled]="isDisabled"
                       [icon]="{ name: 'fa-solid fa-upload'}">
      </rappider-button>
    </div>
  </nz-upload>

  <div *ngIf="config.scrollable && fileList.length > 0"
       class="file-list-scroll-container"
       [style.max-height]="config.maxHeight">
    <div class="file-list-header">
      <span class="file-count">{{ fileList.length }} file(s) selected</span>
    </div>
    <div class="file-list-content">
      <div *ngFor="let file of fileList; trackBy: trackByUid"
           class="file-item">
        <div class="file-item-content">
          <div class="file-icon"
               (click)="config.clickable !== false ? handleFileClick(file) : null">
            <img *ngIf="file.originFileObj && isImageFile(file.originFileObj) && file.thumbUrl"
                 [src]="file.thumbUrl"
                 [alt]="file.name"
                 class="file-thumbnail">
            <i *ngIf="!file.originFileObj || !isImageFile(file.originFileObj) || !file.thumbUrl"
               nz-icon
               [nzType]="getFileIcon(file.name)"></i>
          </div>
          <div class="file-info"
               (click)="config.clickable !== false ? handleFileClick(file) : null">
            <div class="file-name"
                 [title]="file.name">{{ file.name }}</div>
            <div class="file-size">{{ formatFileSize(file.size || 0) }}</div>
          </div>
          <div class="file-actions">
            <rappider-button *ngIf="config?.previewVisibility !== false"
                             [disabled]="isDisabled"
                             [size]="ButtonSize.Small"
                             [type]="ButtonType.Default"
                             [icon]="{ name: 'fa-solid fa-eye' }"
                             (click)="handlePreview(file); $event.stopPropagation()"
                             class="preview-button">
            </rappider-button>

            <rappider-button [disabled]="isDisabled"
                             [size]="ButtonSize.Small"
                             [type]="ButtonType.Default"
                             [icon]="{ name: 'fa-solid fa-trash' }"
                             (click)="handleRemoveFile(file); $event.stopPropagation()"
                             class="remove-button">
            </rappider-button>
          </div>
        </div>
        <!-- Display Image preview inline -->
        <!-- TODO: plan and update for image preview display -->
        <div class="file-preview"
             *ngIf="false && file?.thumbUrl">
          <img [src]="file.thumbUrl"
               style="width: 100%" />
        </div>
      </div>
    </div>
  </div>
</div>

<nz-modal [nzVisible]="showPreviewModal"
          [nzContent]="previewModalContent"
          nzCentered
          nzWidth="80%"
          [nzFooter]="null"
          (nzOnCancel)="showPreviewModal = false">
  <ng-template #previewModalContent>
    <img [src]="previewImage"
         style="width: 100%" />
  </ng-template>
</nz-modal>
